import { Background } from "@xyflow/react";

export const primaryColor = '#c45151ff';

export const dashboardContainerStyle: React.CSSProperties = {
    width: '100%',
    // maxWidth: '1200px',
    backgroundColor: '#f9f9f9',
    boxShadow: '0 14px 40px rgba(13,21,28,0.06)',
    borderRadius: '10px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    // minHeight: '80vh',
};

export const headerStyle: React.CSSProperties = {
    backgroundColor: '#fbfbfb',
    padding: '12px 28px',
    borderBottom: '1px solid #f0f0f0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#222',
};

export const headerLeft: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
};

export const welcomeTitle: React.CSSProperties = {
    margin: 0,
    fontSize: '1.5em',
    fontWeight: '600',
};

export const userEmail: React.CSSProperties = {
    fontSize: '0.9em',
    color: '#666',
};

export const headerRight: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
};

export const profilePicStyle: React.CSSProperties = {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '2px solid rgba(0,0,0,0.06)',
};

export const logoutButtonStyle: React.CSSProperties = {
    backgroundColor: primaryColor,
    color: 'white',
    border: 'none',
    padding: '10px 12px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '0.95em',
    fontWeight: 600,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    lineHeight: 1,
    boxShadow: '0 6px 18px rgba(141,57,57,0.12)',
};


export const contentAreaStyle: React.CSSProperties = {
    display: 'flex',
    flexGrow: 1,
    minHeight: 0, // allow children to control scroll
};

export const sidebarStyle: React.CSSProperties = {
    width: '200px',
    backgroundColor: '#ffffff',
    padding: '22px',
    borderRight: '1px solid #f0f0f0',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
};

export const createButtonStyle: React.CSSProperties = {
    backgroundColor: primaryColor,
    color: 'white',
    border: 'none',
    padding: '12px 18px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '1em',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    marginBottom: '18px',
    boxShadow: '0 8px 20px rgba(141,57,57,0.10)'
};

export const navStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
};

export const navLinkStyle: React.CSSProperties = {
    textDecoration: 'none',
    color: '#444',
    padding: '8px 10px',
    borderRadius: '6px',
    transition: 'background-color 0.15s ease, color 0.15s ease',
    display: 'block'
};

export const mainContentStyle: React.CSSProperties = {
    flexGrow: 1,
    padding: '28px',
    backgroundColor: '#fbfbfb',
    overflowY: 'auto', // Added to enable vertical scrolling when content overflows
    minHeight: 0,
};

export const sectionTitleStyle: React.CSSProperties = {
    fontSize: '1.6em',
    marginBottom: '18px',
    color: '#222',
};

export const tableStyle: React.CSSProperties = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
    backgroundColor: '#fff',
};

export const thStyle: React.CSSProperties = {
    textAlign: 'left',
    padding: '12px 15px',
    backgroundColor: '#f9f9f9',
    borderBottom: '2px solid #eee',
    color: '#555',
    fontWeight: 600,
};

export const tdStyle: React.CSSProperties = {
    padding: '12px 15px',
    borderBottom: '1px solid #dee2e6',
    verticalAlign: 'middle',
    color: '#333',
};

export const trStyle: React.CSSProperties = {
    transition: 'background-color 0.2s ease',
};

export const actionButtonStyle: React.CSSProperties = {
    backgroundColor: primaryColor,
    color: 'white',
    border: 'none',
    padding: '8px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.9em',
    marginRight: '8px',
    transition: 'transform 0.06s ease, box-shadow 0.12s ease',
    boxShadow: '0 6px 16px rgba(141,57,57,0.08)'
};

export const noDocsStyle: React.CSSProperties = {
    textAlign: 'center',
    padding: '50px',
    color: '#777',
    fontSize: '1.1em',
};